import { ApiRoutes } from "../../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../../base";
import {
  OrderTemporaryReleaseStockRequestBody,
  OrderTemporaryReleaseStockResponse,
} from "./types";

export class OrderTemporaryReleaseStockAPI extends BaseAPI<
  OrderTemporaryReleaseStockRequestBody,
  OrderTemporaryReleaseStockResponse
> {
  protected route = ApiRoutes.order.temporary_release_stock;
  protected method = RequestMethod.POST;
}
